import { http } from '../../../../api/http';

export interface FlujoCajaFila {
  tipo: string;
  cuentaContable: string | null;
  descripcion: string;
  nivel: number;
  montosPorPeriodo: Record<string, number>;
  esSubtotal: boolean;
}

export interface FlujoCajaResponse {
  periodos: string[];
  filas: FlujoCajaFila[];
}

export interface FlujoCajaPresupuesto {
  idFlujoCajaPresupuesto: number;
  ejercicio: string;
  periodo: string;
  cuentaContable: string;
  nombreCuenta: string | null;
  tipoFlujo: string;
  idMoneda: number;
  monedaSimbolo: string | null;
  tipoCambio: number;
  montoPresupuestado: number;
  montoEjecutado: number;
  diferencia: number;
}

export interface FlujoCajaFiltro {
  ejercicio: string;
  periodoInicio: string;
  periodoFin: string;
  idMoneda?: number;
}

const ENDPOINT = '/tesoreria/flujo-caja';

export class FlujoCajaService {
  public static async getFlujoCaja(filtro: FlujoCajaFiltro): Promise<FlujoCajaResponse> {
    const params = new URLSearchParams();
    params.append('ejercicio', filtro.ejercicio);
    params.append('periodoInicio', filtro.periodoInicio);
    params.append('periodoFin', filtro.periodoFin);
    if (filtro.idMoneda) params.append('idMoneda', filtro.idMoneda.toString());
    const response = await http.get(`${ENDPOINT}?${params.toString()}`);
    return response.data;
  }

  public static async getPresupuestos(ejercicio: string): Promise<FlujoCajaPresupuesto[]> {
    const response = await http.get(`${ENDPOINT}/presupuesto?ejercicio=${ejercicio}`);
    return response.data;
  }

  public static async savePresupuesto(presupuesto: Partial<FlujoCajaPresupuesto>): Promise<FlujoCajaPresupuesto> {
    const response = await http.post(`${ENDPOINT}/presupuesto`, presupuesto);
    return response.data;
  }
}
